import React, { useState } from 'react';
import useFetch from 'use-http';
import { ILeaseCheck } from 'src/models/dlcLease/ILeaseCheck';
import CheckDetailsModal from './CheckDetailsModal';
import CheckMatchPickerModal from './CheckMatchPickerModal';
import DirectLookup from 'src/components/common/DirectLookup';

const FindCheck: React.FC = () => {
    const [checkNoInput, setCheckNoInput] = useState('');
    const [searchedCheckNo, setSearchedCheckNo] = useState('');
    const [matches, setMatches] = useState<ILeaseCheck[]>([]);
    const [selectedCheck, setSelectedCheck] = useState<ILeaseCheck | null>(null);
    const [error, setError] = useState<string | null>(null);
    const { get, loading, response } = useFetch();

    // Fetch Logic
    const handleFindClick = async () => {
        if (!checkNoInput) {
            return;
        }

        setError(null);
        setMatches([]);
        setSelectedCheck(null);

        try {
            const url = `/v1.0/leases/master/checks/${checkNoInput}`;
            const data = await get(url);

            if (!response.ok) {
                setError(typeof data === 'string' && data ? data : 'Unable to search for that check.');
                return;
            }

            // The endpoint returns every check carrying this number -- the same number gets reused
            // across companies. One hit opens straight up; several make the user pick.
            const found: ILeaseCheck[] = Array.isArray(data) ? data : data ? [data] : [];

            if (found.length === 0) {
                setError('Check not found.');
                return;
            }

            setSearchedCheckNo(checkNoInput);

            if (found.length === 1) {
                setSelectedCheck(found[0]);
            } else {
                setMatches(found);
            }
        } catch {
            setError('Error searching.');
        }
    };

    const handleCloseModal = () => {
        setSelectedCheck(null);
    };

    const handleClosePicker = () => {
        setMatches([]);
    };

    const handleSelectMatch = (check: ILeaseCheck) => {
        setMatches([]);
        setSelectedCheck(check);
    };

    return (
        <>
            <DirectLookup
                value={checkNoInput}
                onValueChange={(value) => {
                    setCheckNoInput(value);
                    setError(null);
                }}
                onSubmit={handleFindClick}
                placeholder="Check number"
                ariaLabel="Check number"
                buttonLabel="Find Check"
                loading={loading}
                loadingLabel="Finding..."
                error={error}
                inputMode="numeric"
            />

            {/* Ambiguous check number -- let the user choose which check they meant */}
            {matches.length > 1 && (
                <CheckMatchPickerModal checkNo={searchedCheckNo} matches={matches} onSelect={handleSelectMatch} onClose={handleClosePicker} />
            )}

            {/* Render Modal if check is found */}
            {selectedCheck && <CheckDetailsModal check={selectedCheck} onClose={handleCloseModal} />}
        </>
    );
};

export default FindCheck;



// WEBPACK FOOTER //
// ./src/components/invoicing/components/FindCheck.tsx